
(function(){const r=document.getElementById('cmprange');if(!r)return;
const clip=document.getElementById('cmpclip'),h=document.getElementById('cmphandle');
r.addEventListener('input',()=>{clip.style.clipPath='inset(0 0 0 '+r.value+'%)';h.style.left=r.value+'%';});})();
function revToggle(){document.getElementById('revform').classList.toggle('open')}
function revSubmit(e){e.preventDefault();document.getElementById('revform').classList.remove('open');document.getElementById('revok').style.display='block'}
document.addEventListener('DOMContentLoaded',()=>{
const ai=document.getElementById('anatomyimg'); if(ai) ai.src=document.getElementById('mainphoto').src;const st=[...document.querySelectorAll('#rstars span')];
st.forEach((s,i)=>s.onclick=()=>st.forEach((x,j)=>x.classList.toggle('lit',j<=i)));});
function bRecalc(){
  const sel=[...document.querySelectorAll('.bitem.on')];
  const roomLbl=document.querySelector('.rooms label.sel');
  const base=parseFloat((roomLbl||{dataset:{price:'108'}}).dataset.price)||108;
  const is2R=!roomLbl||roomLbl.dataset.rooms==='2';
  const addons=sel.reduce((s,x)=>s+ +x.dataset.price,0);
  const nAdd=sel.length;
  const count=nAdd+((is2R&&nAdd)?1:0);
  const rate=count>=4?0.20:count>=2?0.10:0;
  const discBase=((is2R&&nAdd)?base:0)+addons;
  const save=discBase*rate;
  const txt=document.getElementById('btxt'),tot=document.getElementById('btot'),cta=document.getElementById('bcta');
  if(nAdd){
    if(rate>0){
      const what=is2R?'% off your whole bundle':'% off add-ons';
      txt.innerHTML=count+' items — <b>'+(rate*100)+what+'</b> (save $'+save.toFixed(2)+'), applied automatically at checkout'+(count>=4?'':' · add '+(4-count)+' more for 20%');}
    else{txt.innerHTML='1 add-on — add 1 more and both are <b>10% off</b> at checkout';}
    tot.innerHTML=(save>0?'<s>$'+(base+addons).toFixed(2)+'</s>':'')+'$'+(base+addons-save).toFixed(2);
    cta.textContent='Add Lattice + '+nAdd+' to cart';}
  else{txt.textContent='Select add-ons above — bundle savings apply automatically at checkout.';tot.textContent='';cta.textContent='Add Lattice to cart';}}
function bToggle(el){el.classList.toggle('on');bRecalc();}
// variant selector visual + price sync (mockup only — wire to Shopify variants)
function swapImg(el){var m=document.getElementById('mainphoto');if(!m)return;m.src=el.src;
var sib=el.parentElement.children;for(var i=0;i<sib.length;i++){sib[i].classList.toggle('on',sib[i]===el);}}
window.swapImg=swapImg;
const labels=[...document.querySelectorAll('.rooms label')];
labels.forEach(l=>l.addEventListener('click',()=>{
  labels.forEach(x=>x.classList.remove('sel')); l.classList.add('sel');
  l.querySelector('input').checked=true;
  const p=parseFloat(l.dataset.price), rooms=+l.dataset.rooms;
  document.getElementById('bp').textContent="$"+(p%1?p.toFixed(0):p.toFixed(0));
  document.getElementById('perroom').textContent="$"+Math.round(p/rooms)+" per room";
  document.getElementById('incl').textContent=rooms;
  document.getElementById('stickyprice').textContent="$"+p.toFixed(2);
  document.querySelector('.installs b').textContent="$"+(p/4).toFixed(2);
  document.querySelector('.atc').dataset.variantId=l.dataset.variantId;
  document.getElementById('bpatc').dataset.variantId=l.dataset.variantId;
  document.getElementById('bpprice').textContent='$'+(p%1?p.toFixed(2):p.toFixed(0));
  if(window.bRecalc)bRecalc();
}));
const ccSelectedVariant=()=>document.querySelector('.atc').dataset.variantId;
const ccCartAdd=async()=>{await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+ccSelectedVariant(),quantity:1}]})});window.location='/cart';};
document.querySelector('.atc').addEventListener('click',ccCartAdd);
document.querySelector('#sticky button').addEventListener('click',ccCartAdd);
/* ShopPay button → straight to Shopify checkout (permalink), where ShopPay is offered */
document.querySelector('.shoppay').addEventListener('click',()=>{
  window.location='/cart/'+ccSelectedVariant()+':1';
});
/* More payment options → cart page; all wallets appear at checkout */
document.querySelector('.morepay').addEventListener('click',ccCartAdd);
/* Bundle CTA → multi-item cart permalink (Lattice + selected add-ons) */
const CC_LATTICE_DUP='46450038309034';
function ccBundleItems(){
  const addons=[...document.querySelectorAll('.bitem.on')].map(b=>b.dataset.variantId+':1');
  const roomLbl=document.querySelector('.rooms label.sel');
  const is2R=(!roomLbl||roomLbl.dataset.rooms==='2')&&addons.length>0;
  return [(is2R?CC_LATTICE_DUP:ccSelectedVariant())+':1'].concat(addons);
}
document.getElementById('bcta').addEventListener('click',()=>{
  var payload=ccBundleItems().map(function(s){var p=s.split(':');return {id:+p[0],quantity:+p[1]};});fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:payload})}).then(function(){window.location='/cart';});
});
(function(){const rc=document.querySelector('.rev-cards');if(!rc)return;
const gap=18, step=()=>rc.querySelector('.rev-card').getBoundingClientRect().width+gap;
const atEnd=()=>rc.scrollLeft+rc.clientWidth>=rc.scrollWidth-10;
document.querySelector('.rev-arrow.next').addEventListener('click',()=>{atEnd()?rc.scrollTo({left:0}):rc.scrollBy({left:step()});});
document.querySelector('.rev-arrow.prev').addEventListener('click',()=>{rc.scrollLeft<10?rc.scrollTo({left:rc.scrollWidth}):rc.scrollBy({left:-step()});});
let timer=null;
const auto=()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  timer=setInterval(()=>{atEnd()?rc.scrollTo({left:0}):rc.scrollBy({left:step()});},4500);};
const stop=()=>{if(timer){clearInterval(timer);timer=null;}};
const car=document.querySelector('.rev-carousel');
car.addEventListener('mouseenter',stop);
car.addEventListener('mouseleave',()=>{if(!timer)auto();});
car.addEventListener('touchstart',stop,{passive:true});
auto();})();
document.querySelectorAll('#faqList .faq-q').forEach(q=>{q.addEventListener('click',()=>{
  const item=q.parentElement,wasOpen=item.classList.contains('open');
  document.querySelectorAll('#faqList .faq-item').forEach(it=>{it.classList.remove('open');it.querySelector('.faq-a').style.maxHeight=null;});
  if(!wasOpen){item.classList.add('open');const a=item.querySelector('.faq-a');a.style.maxHeight=a.scrollHeight+'px';}
});});
const firstOpen=document.querySelector('#faqList .faq-item.open .faq-a');
if(firstOpen)firstOpen.style.maxHeight=firstOpen.scrollHeight+'px';


const bpa=document.getElementById('bpatc');
if(bpa){bpa.dataset.variantId=bpa.dataset.variantId||'37566833524906';
bpa.addEventListener('click',e=>{e.preventDefault();
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+bpa.dataset.variantId,quantity:1}]})}).then(()=>window.location='/cart');});}

/* live inventory: stock line + button state follow the selected variant */
(function(){var el=document.getElementById('ccstock'),dataEl=document.getElementById('cc-variants');
if(!el||!dataEl)return;var variants={};
try{JSON.parse(dataEl.textContent).forEach(function(v){variants[v.id]=v;});}catch(e){return;}
function upd(){var vid=+(document.querySelector('.atc').dataset.variantId||37566833524906);
var v=variants[vid];if(!v)return;var ok=v.available;
var low=ok&&v.inventory_management&&v.inventory_quantity>0&&v.inventory_quantity<=5;
el.textContent=ok?(low?('\u2713 Only '+v.inventory_quantity+' left \u2014 ships within 1 business day'):'\u2713 In stock \u2014 ships within 1 business day'):'Out of stock \u2014 temporarily unavailable';
el.style.color=ok?'':'#A33333';
['.atc','.shoppay'].forEach(function(s){var b=document.querySelector(s);
if(b){b.disabled=!ok;b.style.opacity=ok?'':'0.5';b.style.cursor=ok?'':'not-allowed';}});}
document.querySelectorAll('.rooms label').forEach(function(l){l.addEventListener('click',function(){setTimeout(upd,0);});});
upd();})();
